import {gsap} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {IBigWinLevel, PearlHarborWinConfigs} from "../configs/PearlHarborWinConfigs";
import {PearlHarbor} from "../PearlHarbor";
import {PearlHarborGameMode} from "../server/PearlHarborGameMode";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";

export class PearlHarborBigWinRunner implements SimplePresentation {

    private _bigWinLevels:IBigWinLevel[];

    private static skip(level:number):void {
        PearlHarbor.totalBigWinView.onAbort(level);
    }

    public shouldRun():boolean {
        const isCloseGameRound:boolean = (PearlHarbor.model.gameData.nextMode === PearlHarborGameMode.NORMAL || PearlHarbor.model.gameData.freespinTriggeredThisSpin);

        if(PearlHarbor.model.gameData.brokeBank) {
            return false;
        }
        if(!isCloseGameRound || (PearlHarbor.model.gameData.accumulatedRoundWin === 0)) {
            return false;
        }

        this._bigWinLevels = PearlHarborWinConfigs.getBigWinLevels(PearlHarbor.model.winRatio);
        return (this._bigWinLevels.length > 0);
    }

    public start(controller:SimplePresentationRunnerController):void {
        const levels:IBigWinLevel[] = this._bigWinLevels,
            isFSOutroTriggering:boolean = (PearlHarborHelper.isFreeSpin(PearlHarbor.model.gameData.mode) && PearlHarbor.model.gameData.nextMode === PearlHarborGameMode.NORMAL),
            delay:number = ((isFSOutroTriggering && !PearlHarbor.model.gameData.brokeBank) ? PearlHarbor.DELAY_BEFORE_OUTRO : 0),
            tl:gsap.core.Timeline = gsap.timeline({
                delay : delay
            });

        PearlHarbor.bigWinPlayed = true;

        PearlHarbor.totalBigWinView.precalculateScale(PearlHarbor.model.winRatio * PearlHarbor.model.gameData.playedBetValue);
        for(let index:number = 0; index < levels.length; index++) {
            const bigWinLevel:IBigWinLevel = levels[index],
                from:number = bigWinLevel.from * PearlHarbor.model.gameData.playedBetValue,
                to:number = (index === (levels.length - 1)) ? PearlHarbor.model.gameData.accumulatedRoundWin : Math.min(bigWinLevel.to * PearlHarbor.model.gameData.playedBetValue, PearlHarbor.model.gameData.accumulatedRoundWin),
                startTime = tl.duration();

            tl.add(() => {
                controller.setSkipCallback(() => {
                    PearlHarborBigWinRunner.skip(bigWinLevel.id);
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            }, startTime + (bigWinLevel.id === 1 ? 1.103 : 0));
            tl.add(PearlHarbor.totalBigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id), startTime);
            tl.addLabel(bigWinLevel.type + "_end");
        }

        tl.add(PearlHarbor.totalBigWinView.show(0.1), 0);
        tl.add(() => {
            SlotGame.keypadPlugin.setWin(PearlHarbor.model.gameData.accumulatedRoundWin, true, PearlHarborHelper.isWinBelowStake());
            PearlHarbor.totalBigWinView.hide(1.2);
        });
        tl.add(() => {
            controller.finish();
        });
    }
}